<div class="flex container">
  <div class="flex one">
    <div class="flex half-1" style="position: relative;">
      <img [src]="MileleLogoPath" class="milele-logo" alt="logo" (click)="navHome()" />
      <div class="flex power-small"> {{ powerdByText }} </div>
    </div>
    <div class="flex half-2"></div>
  </div>

  <div class="flex two">
    <img [src]="logoPath" class="logo" alt="logo" />
  </div>

  <div class="flex content-holder">
    <div class="flex content-wrapper">
      
      <div class="tabs-wrapper" *ngIf="activeTab !== 8">
        <div class="tabs">
          <div [@slideIn]="tabsAnimationState[0]" class="tab" [class.active]="activeTab === 1" [ngClass]="{'done' : page1DoneEstate}">
            <div class="round">1</div>
            <span style="text-wrap: nowrap; text-overflow: ellipsis; word-break: break-all; overflow: hidden;">
              {{planType === 0 ? 'Settlor' : 'Testator'}}
            </span>
          </div>

          <div [@slideIn]="tabsAnimationState[1]" class="tab" [class.active]="activeTab === 2" [ngClass]="{'done' : page2DoneEstate}">
            <div class="round">2</div>
            {{ 'Payment' }}
          </div>

          <div [@slideIn]="tabsAnimationState[2]" class="tab" [class.active]="activeTab === 3" [ngClass]="{'done' : page3DoneEstate}">
            <div class="round">3</div>
            {{planType === 0 ? 'Beneficiaries' : 'Will Executor'}}
          </div>

          <div [@slideIn]="tabsAnimationState[3]" class="tab" [class.active]="activeTab === 4" [ngClass]="{'done' : page4DoneEstate}">
            <div class="round">4</div>
            {{ 'Assets' }}
          </div>

          <div [@slideIn]="tabsAnimationState[4]" class="tab" [class.active]="activeTab === 5" [ngClass]="{'done' : page5DoneEstate}">
            <div class="round">5</div>
            {{planType === 0 ? 'Trustees' : 'Beneficiaries'}}
          </div>

          <div [@slideIn]="tabsAnimationState[5]" class="tab" [class.active]="activeTab === 6" [ngClass]="{'done' : page6DoneEstate}">
            <div class="round">6</div>
            {{planType === 0 ? 'Enforcer' : 'Witness'}}
          </div>

          <div [@slideIn]="tabsAnimationState[6]" class="tab" [class.active]="activeTab === 7">
            <div class="round">7</div>
            {{'Preview'}}
          </div>
        </div>
      </div>

      <div class="flex center content-back" *ngIf="loadingTab">
        <div class="flex loading-spinner" style="margin-top: 15%; margin-bottom: 15%;">
          <mat-progress-spinner mode="indeterminate" color="warn" diameter="100" strokeWidth="10"></mat-progress-spinner>
        </div>
      </div>

      <div class="content" *ngIf="!loadingTab && (planType == 0 && activeTab !== 8)">
        <div class="subcontent" *ngIf="activeTab === 1">
          <app-step1-settlors class="subcontent"></app-step1-settlors>
        </div>
        <div class="subcontent" *ngIf="activeTab === 2 && page1DoneEstate">
          <app-step2-payment-estate class="subcontent"></app-step2-payment-estate>
        </div>
        <div class="subcontent" *ngIf="activeTab === 3 && page2DoneEstate">
          <app-step3-beneficiary-estate class="subcontent"></app-step3-beneficiary-estate>
        </div>
        <div class="subcontent" *ngIf="activeTab === 4 && page3DoneEstate">
          <app-step4-assets class="subcontent"></app-step4-assets>
        </div>
        <div class="subcontent" *ngIf="activeTab === 5 && page4DoneEstate">
          <app-step5-trustee class="subcontent"></app-step5-trustee>
        </div>
        <div class="subcontent" *ngIf="activeTab === 6 && page5DoneEstate">
          <app-step6-enforcer class="subcontent"></app-step6-enforcer>
        </div>
        <div class="subcontent" *ngIf="activeTab === 7 && page6DoneEstate">
          <app-step7-previews class="subcontent"></app-step7-previews>
        </div>
      </div>

      <div class="content" *ngIf="!loadingTab && (planType == 1 && activeTab !== 8)">
        <div class="subcontent" *ngIf="activeTab === 1">
          <app-step1-testator class="subcontent"></app-step1-testator>
        </div>
        <div class="subcontent" *ngIf="activeTab === 2 && page1DoneEstate">
          <app-step2-payment-will class="subcontent"></app-step2-payment-will>
        </div>
        <div class="subcontent" *ngIf="activeTab === 3 && page2DoneEstate">
          <app-step3-executor class="subcontent"></app-step3-executor>
        </div>
        <div class="subcontent" *ngIf="activeTab === 4 && page3DoneEstate">
          <app-step4-assets class="subcontent"></app-step4-assets>
        </div>
        <div class="subcontent" *ngIf="activeTab === 5 && page4DoneEstate">
          <app-step3-beneficiary-estate class="subcontent"></app-step3-beneficiary-estate>
        </div>
        <div class="subcontent" *ngIf="activeTab === 6 && page5DoneEstate">
          <app-step6-witness class="subcontent"></app-step6-witness>
        </div>
        <div class="subcontent" *ngIf="activeTab === 7 && page6DoneEstate">
          <app-step7-previews class="subcontent"></app-step7-previews>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #modalContent>
  <div class="flex column">
    <ol style="margin-top: 32px; color: black; text-align: justify; box-sizing: border-box; padding-left: 24px; padding-right: 24px;">
      <li>The Onboarding session might take at least <strong>20 minutes</strong> to complete</li>
      <li>
        Kindly prepare soft copies of your <strong>Kenyan National ID/Passport</strong> and <strong>KRA PIN</strong>,
        as well as the same documents <strong>(</strong>including <strong>Birth Certificates</strong> for <strong>Minors)</strong>
        for all individuals to be added to the Trust, for ease of onboarding.
      </li>
      <!-- Only appears for diaspora clients -->
      <li *ngIf="regionType === 1">
        The <strong>KRA PIN</strong> is <strong>optional</strong> for Beneficiaries and Guardians added to the Trust Fund.
      </li>
      <li>The payment options available to you are: <strong>M-PESA</strong> and <strong>RTGS / Bank Receipt</strong></li>
    </ol>
  </div>
</ng-template>